


import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend, ChartDataLabels);


const BarChart = ({ chartData }) => {
  if (!chartData || !chartData.labels || !chartData.datasets) {
    return <div>Loading chart...</div>;
  }

  const allValues = chartData.datasets.flatMap((dataset) => dataset.data);
  const maxValue = Math.max(...allValues, 0);
  const dynamicMax = Math.ceil(maxValue * 1.05);

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      tooltip: {
        callbacks: {
          label: function (context) {
            return `${context.dataset.label}: ${context.formattedValue}`;
          },
        },
      },
      datalabels: {
        color: "#b8b6b6",
      },
      legend: {
        position: "bottom",
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        max: dynamicMax,
      },
    },
  };
  return (
    <div style={{ height: "400px" }}>
      <Bar data={chartData} options={options} />
    </div>
  );
};
export default BarChart;